import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=c59424f6&scoped=true&"
import script from "./ModalWindow.vue?vue&type=script&lang=ts&"
export * from "./ModalWindow.vue?vue&type=script&lang=ts&"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=c59424f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59424f6",
  null
  
)

export default component.exports